import { endpoints } from '../endpoints';
import { httpClient } from '../../lib/http-client';
import {
  transactionsResponseSchema,
  transactionSchema,
  type Transaction,
} from '../../schemas/transaction';
/**
 * Fetches a list of all transactions.
 */
export async function fetchTransactions(): Promise<Transaction[]> {
  const { data } = await httpClient.get(endpoints.transaction.list);
  return transactionsResponseSchema.parse(data).transactions;
}

/**
 * Fetches the details of a specific transaction by its ID.
 */
export async function fetchTransaction(id: string): Promise<Transaction> {
  const { data } = await httpClient.get(endpoints.transaction.detail(id));
  return transactionSchema.parse(data.transaction ?? data);
}

/**
 * Fetches all transactions belonging to a specific user.
 */
export async function fetchTransactionsByUser(userId: string): Promise<Transaction[]> {
  const { data } = await httpClient.get(endpoints.transaction.user(userId));
  return transactionsResponseSchema.parse(data).transactions;
}

/**
 * Fetches transactions for a multiple users at once.
 * The list of user IDs is encoded as a JSON string in the URL.
 */
export async function fetchTransactionsByUsers(userIds: string[]): Promise<Transaction[]> {
  // Fix: encodeURIComponent ensures correct URL encoding for the JSON array
  const encoded = encodeURIComponent(JSON.stringify(userIds));
  const { data } = await httpClient.get(endpoints.transaction.users(encoded));
  return transactionsResponseSchema.parse(data).transactions;
}

/**
 * Updates multiple transactions in a single batch request.
 */
export async function updateBatchTransactions(transactions: Transaction[]): Promise<Transaction[]> {
  const { data } = await httpClient.put(endpoints.transaction.updateBatch, { transactions });
  return transactionsResponseSchema.parse(data).transactions;
}
